// import axios, { HttpStatusCode } from 'axios';
import axios from 'axios';
// import * as CryptoJS from 'crypto-js';

import authHeader from './auth-header';

const URL_V3_API = 'https://api.squaregolf.com/v3/wallet';

class _WalletService {
  private accessToken: string | null = null;
  
  constructor() {
    // console.log(`WalletService:: constructor()`);
    let accessToken = localStorage.getItem('accessToken');

    if (accessToken) {
      this.accessToken = accessToken;
    }
  }

  getWallets = async(_userUuid: string) => {
    let userUuid = localStorage.getItem("sub");

    if (_userUuid)
      userUuid = _userUuid;

    return axios.get(URL_V3_API + "/", {
        headers: authHeader(),
        withCredentials: true,
        params: { 
          userUuid: userUuid,
          withCoupons: true,
        }
      })
      .then((res) => {
        // console.log(`wallets: ${JSON.stringify(res.data, null, 2)}`);

        return res;        
      });
  }
}

const WalletService = new _WalletService();
export default WalletService;
